import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { resource } from "@util/resource";
import { DWS } from "@interfaces/dws";
import { EmailMessageData } from "@interfaces/dws/email-message";

@Injectable({
    providedIn: 'root'
})
export class ManageEmailSendingService {
    constructor() {}

    list(
        externalEntityId: string,
        page = 0,
        count = 999999,
        sortBy?: string
    ): Observable<DWS.Page<EmailMessageData>> {
        return resource("crm://email-messages")
            .params({ externalEntityId, page, count, sortBy })
            .get<DWS.Page<EmailMessageData>>();
    }

    cancel(emailMessageId: number): Observable<void> {
        return resource("crm://email-messages/id/cancel").params({ id: emailMessageId }).put<void>();
    }

    reactivate(emailMessageId: number): Observable<void> {
        return resource("crm://email-messages/id/reactivate").params({ id: emailMessageId }).put<void>();
    }
}